export default __webpack_public_path__ + "assets/ukraine-flag.png";